import React from "react";
import styled from "styled-components";
import {GreenButton, RedButton} from "../buttons/ButtonStyles";
import {FunctionalModal} from "./FunctionalModal";
import {BaseModal} from "./modalStyle";

const YesNoModal = ({
                         name,
                         setOpenModal,
                         id,
                         handleClickYesAction,
                         isDeleteAction = true,
                         title
                     }) => {

    const modalTitle = isDeleteAction ? `Êtes-vous sûr de vouloir supprimer ${name}` : title + "?"


    const displayModal = () => {
        return (
            <Modal>
                <h5 className={"mar-bot-05"}> {modalTitle} </h5>
                <ButtonsContainer>
                    <YesButton onClick={() => handleClickYesAction(id)}>
                        <p> Oui </p>
                    </YesButton>
                    <NoButton onClick={() => setOpenModal(false)}>
                        <p> Non </p>
                    </NoButton>
                </ButtonsContainer>
            </Modal>
        )
    }
    return (
        <FunctionalModal setOpen={setOpenModal} component={displayModal()}/>
    )
}

export default YesNoModal;

const Modal = styled(BaseModal)`
  gap: 1rem;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 2em;
  width: 80vw;
  height: fit-content;
  @media (min-width: 768px) {
    width: 400px;
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  gap: 1rem;
`
const YesButton = styled(GreenButton)`
  flex-grow: 1;
`

const NoButton = styled(RedButton)`
  flex-grow: 1;
  height: 2.5rem;
`
